import * as B from '@blueprintjs/core';
import React from 'react';
import ReactDOM from 'react-dom';

import {MapControlPosition} from 'app/components/DeclarativeMap';
import MapContent from 'app/components/DeclarativeMap/MapContent';
import {PortalControl} from 'app/utils/mapUtils';

import cs from './styles.module.scss';

interface Props {
  map: mapboxgl.Map;
  isMapLoaded: boolean;
  position: MapControlPosition;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  disabled: boolean;
}

const ImageryTimelineButton: React.FunctionComponent<Props> = ({
  map,
  isMapLoaded,
  position,
  isOpen,
  setIsOpen,
  disabled,
}) => {
  const [controlEl] = React.useState(() => document.createElement('div'));
  const control = React.useMemo(() => new PortalControl(controlEl), [controlEl]);

  return (
    <>
      <MapContent
        map={map}
        isMapLoaded={isMapLoaded}
        controls={[control]}
        controlPosition={position}
      />
      {ReactDOM.createPortal(
        <B.Tooltip
          content="Imagery timeline"
          position={position === 'top-left' ? B.Position.RIGHT : B.Position.LEFT}
        >
          <B.AnchorButton
            className={cs.controlButton}
            active={isOpen}
            disabled={disabled}
            icon="play"
            onClick={() => setIsOpen(!isOpen)}
          />
        </B.Tooltip>,
        controlEl
      )}
    </>
  );
};

export default ImageryTimelineButton;
